import { PROJECTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/projects_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'projectsIndex',
	'WORK_ORDER_FORM_PROJECTS_AUTOCOMPLETE',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
